/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Binding_Queues_DetailInputs */

const en_marketing_binding_queues_detail = /** @type {(inputs: Marketing_Binding_Queues_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typed background jobs with a dead-letter queue.`)
};

const es_marketing_binding_queues_detail = /** @type {(inputs: Marketing_Binding_Queues_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajos en segundo plano tipados con una cola de mensajes fallidos.`)
};

const fr_marketing_binding_queues_detail = /** @type {(inputs: Marketing_Binding_Queues_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches de fond typées avec une file de rebut.`)
};

/**
* | output |
* | --- |
* | "Typed background jobs with a dead-letter queue." |
*
* @param {Marketing_Binding_Queues_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_binding_queues_detail = /** @type {((inputs?: Marketing_Binding_Queues_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Binding_Queues_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_binding_queues_detail(inputs)
	if (locale === "es") return es_marketing_binding_queues_detail(inputs)
	return fr_marketing_binding_queues_detail(inputs)
});